import { ref, reactive, toRefs, nextTick } from 'vue'
import { getThirdAdIdByplanIds, checkBatchTask, bindMultipleMaterials, getRejectReason } from '@/api/ptom.data.model'
import { batchOperatorPlan, asyncRaiseStates, setRaise, getPlanInfo } from '@/api/convert.model'
import { checkCreative } from '@/api/toutiao.model'
import { hasCreative } from '@/api/uc.model'
import { existCreative } from '@/api/tencent.model'
import { beCreative } from '@/api/baidu.model'
import { ksCreative } from '@/api/kuaishou.model'
import { setLocalInfo, debounce, isArray } from '@/common/js/utils'
import { MEDIAS } from '@/common/js/constants.js'

export function useTableActions(props, emit, proxy, helpers) {
  const { custom, getDateRange } = helpers

  const state = reactive({
    selectList: [],
    betchErr: [],
    betchShow: false,
    betchCheck: [],
    betchCopy: null,
    betchRaise: [],
    betchAsync: null,
    bindingModal: false,
    bindLoading: false,
    bindForm: {
      daterange: getDateRange()
    }
  })

  const auditRejectReasonMap = new Map()

  const onSelectionChange = (val) => {
    state.selectList = val
  }

  const changeActive = (row) => {
    const { mediaOptStatus } = row
    proxy.$set(row, 'optLoading', true)
    betch([0, 1, 0][mediaOptStatus], [row])
  }

  const changeRaise = (row) => {
    if (![16, 10].includes(row.mediaId)) {
      proxy.$Message.error('暂不支持！')
      return
    }
    proxy.$set(row, 'optLoading', true)
    asyncRaise([row.planId])
  }

  const asyncRaise = (ids) => {
    state.betchRaise = []
    asyncRaiseStates({ planIds: ids })
      .then((data) => {
        if (isArray(data)) {
          const hasErr = data.some((ret) => !ret.success)
          data.forEach((ret) => {
            const item = props.data.filter((met) => met.planId === ret.planId).pop()
            if (item) {
              proxy.$set(item, 'raiseStatus', ret.raiseStatus)
              proxy.$set(item, 'optLoading', false)
            }
          })
          if (proxy.$refs.table) {
            proxy.$refs.table.clearSelection()
          }
          if (hasErr) {
            state.betchRaise = data
              .filter((ret) => !ret.success)
              .map((ret) => {
                ret.mediaName = custom(ret.mediaId)
                ret.successName = '失败'
                return ret
              })
            state.betchAsync = true
          }
        }
      })
      .catch(() => {
        state.betchRaise = []
      })
  }

  const closeRaise = (row) => {
    const { planId } = row
    proxy.$set(row, 'optLoading', true)
    setRaise({ planId, raiseStatus: 'STOP_RAISE' })
      .then((data) => {
        proxy.$set(row, 'optLoading', false)
        if (data) emit('on-refresh')
      })
      .catch(() => {
        proxy.$set(row, 'optLoading', false)
      })
  }

  const detailClick = (row) => {
    emit('on-detail', row)
  }

  const editClick = async (type, row) => {
    const { planId } = row
    const loading = type === 'idea' ? 'ideaLoading' : 'planLoading'
    const mediaHtml = (media) => {
      let name = ''
      if (media === MEDIAS.TOUTIAO) name = 'create/toutiaov2'
      else if (media === MEDIAS.UC) name = 'create/uc'
      else if (media === MEDIAS.GDT) name = 'create/tencent'
      else if (media === MEDIAS.BAIDU) name = 'create/baidu'
      else if (media === MEDIAS.KUAISHOU) name = 'create/kuaishou'
      return name
    }

    proxy.$set(row, loading, true)
    const res = await getPlanInfo({ planId })

    if (typeof res !== 'symbol') {
      proxy.$set(row, loading, false)
      if (res) {
        const { adAccountId, adAccountName, mediaId, adId, adGroupId, projectId, creativeIds } = res
        setLocalInfo(adAccountId, adAccountName, mediaId)

        if (type === 'idea') {
          let hasCreatives
          const param = { ad_account_id: adAccountId, ad_id: adId }
          if (adAccountId && adId) {
            try {
              if (mediaId === MEDIAS.GDT) hasCreatives = await existCreative(param)
              else if (mediaId === MEDIAS.KUAISHOU) hasCreatives = await ksCreative(param)
              else if (mediaId === MEDIAS.BAIDU) hasCreatives = await beCreative(param)
              else if (mediaId === MEDIAS.UC) hasCreative(param)
              else hasCreatives = await checkCreative(param)
            } catch (err) {
              proxy.$Message.error('判断创意是否存在错误！')
              console.log(err)
              return
            }
          } else {
            proxy.$Message.error('当前创意ID或账号ID不存在')
            return
          }

          if (mediaId === MEDIAS.UC && hasCreatives) {
            proxy.$Message.error({ duration: 5, content: '该推广单元下没有创意！' })
            return
          }

          const edit = isArray(creativeIds) && creativeIds.length && hasCreatives ? '&t=edit' : ''
          if (mediaId === MEDIAS.TOUTIAO) {
            window.open(`/${mediaHtml(mediaId)}/adedit?id=${adId}&acId=${adAccountId}&t=edit`, '_blank')
          } else if (mediaId === MEDIAS.GDT) {
            window.open(`/create/tencentv3/creative-edit?adId=${adId}&projectId=${projectId}&accountId=${adAccountId}`, '_blank')
          } else {
            window.open(`/${mediaHtml(mediaId)}/idea/${adGroupId}/${adId}?plan=${planId}${edit}`)
          }
        } else {
          if (mediaId === MEDIAS.TOUTIAO) {
            window.open(`/${mediaHtml(mediaId)}/projectedit/?id=${projectId}&acId=${adAccountId}&t=edit`, '_blank')
          } else if (mediaId === MEDIAS.GDT) {
            window.open(`/create/tencentv3/plan-edit?projectId=${projectId}&accountId=${adAccountId}`, '_blank')
          } else {
            window.open(`/${mediaHtml(mediaId)}/projectedit/?id=${adId}&acId=${adAccountId}&t=edit`, '_blank')
          }
        }
      }
    }
  }

  const betch = async (type, row) => {
    const ids = row.map((ret) => ret.planId)
    const thirdAds = await getThirdAdIdByplanIds(ids)

    if (isArray(thirdAds) && thirdAds.length) {
      batchOperatorPlan({
        type,
        adIds: thirdAds
      }).then((data) => {
        if (data) {
          const { failNum, rows } = data
          if (failNum && row.length > 1) {
            state.betchErr = rows
            state.betchShow = true
            props.data.forEach((ret) => {
              proxy.$set(ret, 'optLoading', false)
            })
            return
          } else if (failNum && row.length === 1) {
            proxy.$Message.error({ duration: 5, content: rows[0].result })
            proxy.$set(row[0], 'mediaOptStatus', type === 0)
            proxy.$set(row[0], 'optLoading', false)
          } else {
            proxy.$Message.success({ duration: 5, content: '操作成功' })
          }
          emit('on-refresh')
        }
      })
    } else {
      proxy.$Message.error('获取第三方媒体计划ID失败，Code: 20005')
    }
  }

  const changeBetch = (type) => {
    const len = state.selectList.length
    if (!len) {
      proxy.$Message.warning({ duration: 5, content: '当前未选中任何计划，请在列表中选择一个或多个计划再进行此操作。' })
      return
    }

    if (type < 0) {
      proxy.$Modal.confirm({
        title: '提示',
        content: `<p>当前选中${len}条投放计划，确定删除吗？</p>`,
        onOk: () => {
          betch(type, state.selectList)
        }
      })
    } else if (type > 3) {
      const seleIds = state.selectList.filter((ret) => [10, 16].includes(ret.mediaId)).map((ret) => ret.planId)
      props.data.forEach((ret) => {
        proxy.$set(ret, 'optLoading', seleIds.includes(ret.planId))
      })
      asyncRaise(seleIds)
    } else if (type > 2) {
      const seleIds = state.selectList.map((ret) => {
        return {
          planId: ret.planId,
          planName: ret.planName,
          mediaId: ret.mediaId,
          mediaName: ret.mediaName
        }
      })
      checkBatchTask({ list: seleIds }).then((data) => {
        if (isArray(data)) {
          state.betchCheck = data.map((ret) => {
            const { mediaId, planInfos } = ret
            ret.length = ret.planInfos.length
            ret.copyPlan = ret.planInfos.filter((met, id) => id < 5).map((met) => met.taskId)
            ret.megerCreative = mediaId === -30 && planInfos.length > 1
            return ret
          })
          state.betchCopy = true
        }
      })
    } else {
      const seleIds = state.selectList.map((ret) => ret.planId)
      props.data.forEach((ret) => {
        proxy.$set(ret, 'optLoading', seleIds.includes(ret.planId))
      })
      betch(type, state.selectList)
    }
  }

  const getAuditRejectReason = (row) => {
    const { mediaId, planId, adAccountId, adIdForBudget } = row
    if ([MEDIAS.TOUTIAO].includes(mediaId)) {
      const reasons = auditRejectReasonMap.get(planId)
      if (!isArray(reasons)) {
        proxy.$set(row, 'reasonsLoading', true)
        getRejectReason({ accountId: adAccountId, adId: adIdForBudget })
          .then((data) => {
            proxy.$set(row, 'reasonsLoading', false)
            if (isArray(data)) {
              auditRejectReasonMap.set(planId, data)
              proxy.$set(row, 'reasons', data)
            }
          })
          .catch(() => {
            proxy.$set(row, 'reasonsLoading', false)
          })
      } else {
        proxy.$set(row, 'reasons', reasons)
      }
    }
  }

  const showSyncMaterialsBinding = () => {
    const len = state.selectList.length
    if (!len) {
      return proxy.$Message.warning({ duration: 5, content: '当前未选中任何计划，请在列表中选择一个或多个计划再进行此操作。' })
    }
    state.bindingModal = true
  }

  const onMultipleBindCancel = () => {
    state.bindingModal = false
    state.bindForm.daterange = getDateRange()
  }

  const onMultipleBindConfirm = () => {
    const [beginTime, endTime] = state.bindForm.daterange || []
    if (!beginTime || !endTime) {
      return proxy.$Message.warning({ duration: 2, content: '请选择日期区间' })
    }
    state.bindLoading = true
    bindMultipleMaterials({
      planIds: state.selectList.map((s) => s.planId),
      beginTime,
      endTime
    })
      .then((data) => {
        state.bindLoading = false
        if (data) {
          proxy.$Message.success({ duration: 2, content: '提交成功，素材绑定需要10分钟左右，请耐心等待。' })
          onMultipleBindCancel()
        }
      })
      .catch(() => {
        state.bindLoading = false
      })
  }

  return {
    ...toRefs(state),
    onSelectionChange,
    changeActive,
    changeRaise,
    closeRaise,
    detailClick,
    editClick,
    changeBetch,
    getAuditRejectReason,
    showSyncMaterialsBinding,
    onMultipleBindCancel,
    onMultipleBindConfirm,
    auditRejectReasonMap
  }
}
